if( document.readyState !== 'loading' ) {
    //initializeMap();
} else {
    document.addEventListener('DOMContentLoaded', function (event) {
        //initializeMap();
    });
}

jQuery.fn.isInViewport = function () {
    let elementTop = jQuery(this).offset().top;
    let elementBottom = elementTop + jQuery(this).outerHeight();

    let viewportTop = jQuery(window).scrollTop();
    let viewportBottom = viewportTop + jQuery(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

let once = true;
jQuery(window).scroll(function () {
    if (jQuery('.ct_map .map').isInViewport() && once) {
        initializeMap();
        once = false;
    }
});

function initializeMap() {
    mapboxgl.accessToken = 'pk.eyJ1IjoiY3ViZXRlY2giLCJhIjoiY2p1Y3A4OTN5MGhtYjQzcGRqMmM5djNjdiJ9.fGvz8ymLZ1Pd6Cmzo2VFxQ';
    let mapElements = document.querySelectorAll('.ct_map');

    if (mapElements.length < 1) {
        return;
    }

    let maps = new Array();
    mapElements.forEach(function (mapItem) {

        // Map initialization
        let mapId = mapItem.children[0].getAttribute('id');
        let longitude = mapItem.getAttribute('data-lng');
        let latitude = mapItem.getAttribute('data-lat');
        let style = mapItem.getAttribute('data-style');
        let map = new mapboxgl.Map({
            container: mapId,
            style: (style ? style : 'mapbox://styles/mapbox/streets-v11'),
            center: [longitude, latitude],
            zoom: 14,
            minZoom: 7,
            maxZoom: 18
        });

        // Scroll on map: Zoom only with key CTRL
        map.on("wheel", event => {
            if (event.originalEvent.ctrlKey) {
                return;
            }
            event.preventDefault();
        });

        // Marker coordination
        let geojson = {
            type: 'FeatureCollection',
            features: [{
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [longitude, latitude]
                }
            }]
        };

        // Marker initialization
        geojson.features.forEach(function (marker) {
            let el = document.createElement('span');
            el.className = 'markericon fal fa-map-marker-alt';
            new mapboxgl.Marker(el)
                .setLngLat(marker.geometry.coordinates)
                .addTo(map);
        });

        maps.push(map);
    });
}
